module.exports = __webpack_public_path__ + "static/nadlesnictwo_dwukoly-abb10faeea4f83c6d87bd8c2efcb0605.png";